import React from 'react';
interface ToggleSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  description?: string;
}
export function ToggleSwitch({
  label,
  checked,
  onChange,
  description
}: ToggleSwitchProps) {
  return <div className="flex items-center justify-between gap-4 bg-engage-gray2 border border-engage-gray3 rounded-sm px-4 py-3" data-id="element-93" data-mp="3f1rn87neeg60">
      <span className="flex flex-col" data-id="element-94" data-mp="bkt01oonubnb">
        <span className="text-sm font-medium text-engage-gray5" data-id="element-95" data-mp="bjrbcheq1qn4">{label}</span>
        {description && <span className="text-xs text-engage-gray4 mt-0.5" data-id="element-96" data-mp="6n0xm0qe374v">
            {description}
          </span>}
      </span>
      <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={`relative shrink-0 w-12 h-6 rounded-full transition-colors duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-engage-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-engage-gray1 ${checked ? 'bg-engage-yellow' : 'bg-engage-gray3'}`} data-id="element-97" data-mp="1t6jrdxgtmdp">
        <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-engage-white transition-transform duration-200 ease-out ${checked ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-98" data-mp="2amzmz44201rv" />
      </button>
    </div>;
}